export default "__VITE_ASSET__vF0MvNOf__"